export default __webpack_public_path__ + "static/media/checkmark.6baad8ff.svg";